import { STATIC_HOST } from "../consts.js";
export const TAXONOMY_URL = (taxo) => `${STATIC_HOST}/data/taxonomies/${taxo}.json`;
//# sourceMappingURL=api.js.map